import React from 'react';

// === Helpers === //
import * as utils from '@utils';

// === Styles === //
import styled from '@emotion/styled';

const MultilineListItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 650px;
  margin: 15px 0;
`;
const IconWrapper = styled.div`
  padding-right: 24px;
`;

const Icon = styled.img`
  margin: auto;
  min-width: 48px;
  height: 48px;
`;

const TextWrapper = styled.div`
  align-items: center;
  display: flex;
  p {
    margin: 0;
  }
`;

interface MultilineListItemProps {
  alt: string;
  url: string;
  text: string;
}

const MultilineListItem = ({ alt, url, text }: MultilineListItemProps) => {
  return (
    <MultilineListItemWrapper>
      <IconWrapper>
        <Icon src={url} alt={alt}></Icon>
      </IconWrapper>
      <TextWrapper>{utils.SafeHtml(text)}</TextWrapper>
    </MultilineListItemWrapper>
  );
};

export default MultilineListItem;
